import { safeLocalStorageGet, safeLocalStorageRemove, safeLocalStorageSet } from "./storage.js";

// Where a reader goes after signing up from a novel (Like, comment): back to
// that novel's page. Within one tab the App keeps this in state; this stored
// copy covers the usual sign-up, which ends in a confirmation email whose link
// opens /signin later, often in a new tab. Only a novel id is kept, for a day.

const AUTH_RETURN_KEY = "lorvok:authReturn";
/** How long a pending return survives: a confirmation link older than this lands on the catalog. */
export const AUTH_RETURN_TTL_MS = 24 * 60 * 60 * 1000;

/** Remembers the novel to return to once the pending sign-up is confirmed. */
export function rememberAuthReturn(novelId: string, now: number = Date.now()): void {
  safeLocalStorageSet(AUTH_RETURN_KEY, JSON.stringify({ novelId, at: now }));
}

/** Reads and forgets the remembered novel; null when there is none, or it is stale. */
export function takeAuthReturn(now: number = Date.now()): string | null {
  const raw = safeLocalStorageGet(AUTH_RETURN_KEY);
  if (!raw) return null;
  safeLocalStorageRemove(AUTH_RETURN_KEY);
  try {
    const saved = JSON.parse(raw) as { novelId?: unknown; at?: unknown };
    if (typeof saved.novelId !== "string" || !saved.novelId || typeof saved.at !== "number") return null;
    const age = now - saved.at;
    return age >= 0 && age <= AUTH_RETURN_TTL_MS ? saved.novelId : null;
  } catch {
    return null;
  }
}
